import { LogView } from '@lemoncloud/codes-backend-api';

import type { ListResult, Params } from '@codes/shared';
import { webCore } from '@codes/web-core';

import type { GenerateLogsBody, SaveLogsMetaBody } from '../types';

const BACKEND_ENDPOINT = import.meta.env.VITE_OAUTH_ENDPOINT.toLowerCase();

export const fetchLogs = async (params: Params): Promise<ListResult<LogView>> => {
    const { data } = await webCore
        .buildSignedRequest({
            method: 'GET',
            baseURL: `${BACKEND_ENDPOINT}/mocks/logs`,
        })
        .setParams(params)
        .execute<ListResult<LogView>>();

    return data;
};

// 더미 로그 생성 (미리보기 또는 저장)
export const generateLogs = async (body: GenerateLogsBody, save?: boolean): Promise<ListResult<LogView>> => {
    const params = save ? { save: '' } : {};

    const { data } = await webCore
        .buildSignedRequest({
            method: 'POST',
            baseURL: `${BACKEND_ENDPOINT}/mocks/0/logs`,
        })
        .setParams(params)
        .setBody(body)
        .execute<ListResult<LogView>>();

    return data;
};

// 수동 저장 (2단계 방식)
export const saveLogsMeta = async (body: SaveLogsMetaBody): Promise<void> => {
    await webCore
        .buildSignedRequest({
            method: 'POST',
            baseURL: `${BACKEND_ENDPOINT}/mocks/0/meta`,
        })
        .setBody(body)
        .execute();
};
